import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import SelectDropdown from './SelectDropDown';

export default function FontWeightFormatter({ editor }) {
  const value = editor.getTailwindValue({ name: 'fontWeight' })?.value
  const handleClickOption = useCallback(fontWeight => editor.commands.setFontWeight(value === fontWeight ? null : fontWeight), [editor, value])

  return <SelectDropdown
    options={WEIGHTS}
    onChange={handleClickOption}
    tooltipText='Font Weight'
    value={value}
  />
}

const WEIGHTS = [
  { value: 'thin', label: 'Thin (100)' },
  { value: 'extralight', label: 'Extra light (200)' },
  { value: 'light', label: 'Light (300)' },
  { value: 'normal', label: 'Normal (400)' },
  { value: 'medium', label: 'Medium (500)' },
  { value: 'semibold', label: 'Semi bold (600)' },
  { value: 'bold', label: 'Bold (700)' },
  { value: 'extrabold', label: 'Extra bold (800)' },
  { value: 'black', label: 'Black (900)' },
]

FontWeightFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
